export const cleanHexCode = hexCode =>
  hexCode.indexOf('#') === 0 ? hexCode : '#' + hexCode

export const cleanColor = color => color.indexOf('#') === 0 ? (color.substring(1)).toUpperCase() : color.toUpperCase()

export const getTooltipMessage = (orgFlags, isJourney) => {
  if (isJourney) {
    if (orgFlags.quest_maker_flags.indexOf('qm_enable_course_cloning_from_organization') !== -1) {
      return 'No journeys exist within your organization.'
    }
    if (orgFlags.quest_maker_flags.indexOf('qm_enable_course_cloning_from_user') !== -1) {
      return 'You have no existing journeys to copy.'
    }
    return null
  } else {
    if (orgFlags.quest_maker_flags.indexOf('qm_enable_master_course_cloning_from_organization') !== -1) {
      return 'No courses currently exist within your organization.'
    }
    if (orgFlags.quest_maker_flags.indexOf('qm_enable_master_course_cloning_from_user') !== -1) {
      return 'You have no existing courses to copy.'
    }
    return null
  }
}



// WEBPACK FOOTER //
// ./src/components/mycourses/util.js